jQuery(document).ready(function ( $ ) {
	$('.green_slider').slick({
	  slidesToShow: 3,
	  arrows:false,
	  autoplay:false,
	  responsive: [
	    {
	      breakpoint: 959,
	      settings: {
	        slidesToShow: 3
	      }
	    },
	    {
	      breakpoint: 575,
	      settings: {
	        slidesToShow: 1,
	        arrows:true,
	        prevArrow:'<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0707/1282/0030/files/chevron-left-dark.png?v=1704449451"></button>',
	        nextArrow:'<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0707/1282/0030/files/chevron-right-dark.png?v=1704449459"></button>',
	      }
	    }
	  ]
	});
})